// extracted by mini-css-extract-plugin
export default {"modalOverlay":"styles_modalOverlay__SJYoJ","modalContent":"styles_modalContent__csh-o"};